export { default as FranchisesList } from './FranchisesList';
export { default as FranchiseeDetails } from './FranchiseeDetails';
export { default as AddFranchisee } from './AddFranchisee';